import { FlexBox } from "@components/wrapper"
import { ServiceInfo } from "@interfaces/services"
import clsx from "clsx"
import Image from "next/image"

interface ProfessionalScopeProps {
  data: ServiceInfo[]
}

export const ProfessionalScope = ({ data }: ProfessionalScopeProps) => {
  if (!data.length) {
    return <></>
  }

  return (
    <section className={clsx("sm:my-15 my-10")}>
      <h2 className="sm:text-xl text-sm font-semibold text-center mb-5">Bidang Bootcamp Kami</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 sm:gap-7 gap-5">
        {data.map((value, index) => (
          <div
            key={index}
            className={clsx("w-full bg-white sm:p-6 border border-white-f0 rounded", "p-5")}
          >
            <FlexBox
              className={clsx("rounded-full p-2 sm:wh-15 bg-white-f9 mb-3", "w-[45px] h-[45px]")}
            >
              <Image
                src={value.serviceIconUrl}
                alt="icon corporate"
                width={32}
                height={32}
                className="object-contain m-auto sm:wh-8 wh-5"
              />
            </FlexBox>

            <h4 className={clsx("font-semibold sm:text-lg sm:mb-4", "text-sm mb-3")}>
              {value.serviceName}
            </h4>
            <p className="text-black-67 sm-only:text-xxs sm-only:leading-3.5">
              {value.serviceDescription}
            </p>
          </div>
        ))}
      </div>
    </section>
  )
}
